(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__faqAccordion) return;
    window.__faqAccordion = true;
    const running = new WeakMap();

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.faq__question');
      const item = summary?.parentElement;
      if (!item?.matches('.faq__item[data-faq-item]')) return;
      const answer = item.querySelector('[data-faq-answer]');
      if (!answer || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      event.preventDefault();

      const opening = !item.classList.contains('is-open');
      const from = item.open ? answer.offsetHeight : 0;
      running.get(item)?.cancel();
      item.open = true;
      item.classList.toggle('is-open', opening);
      const to = opening ? answer.scrollHeight : 0;
      const animation = answer.animate(
        { height: [`${from}px`, `${to}px`] },
        { duration: 450, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      running.set(item, animation);
      animation.onfinish = () => {
        running.delete(item);
        if (!opening) item.open = false;
      };
    });

    document.addEventListener(
      'toggle',
      (event) => {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.matches('.faq__item') || running.has(item)) return;
        item.classList.toggle('is-open', item.open);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setUnit = (root, unit) => {
      root.querySelectorAll('[data-in]').forEach((el) => { el.hidden = unit !== 'in'; });
      root.querySelectorAll('[data-cm]').forEach((el) => { el.hidden = unit !== 'cm'; });
      root.querySelectorAll('[data-size-chart-unit]').forEach((btn) => {
        const active = btn.dataset.sizeChartUnit === unit;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
    };
    const init = (scope) => scope.querySelectorAll('[data-size-chart]').forEach((root) => setUnit(root, root.dataset.defaultUnit === 'cm' ? 'cm' : 'in'));
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-size-chart-unit]');
      const root = btn?.closest('[data-size-chart]');
      if (root) setUnit(root, btn.dataset.sizeChartUnit);
    });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
